import isNil from 'lodash/isNil';
import negate from 'lodash/negate';

const isNotNilOrEmtyString = v => (negate(isNil, v) && v !== '');

const isNot = (v) => !!v === false;

export {
  isNotNilOrEmtyString,
  isNot,
};
